import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: 'https://www.changelifesys.com/appdata/api'
  //baseURL: 'https://localhost:7238/api'
})

request.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data

  const { data } = response

  if (data.showalert) {
    Message({
      message: data.message || '發生錯誤',
      type: 'error'
    })
  }

  return data
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if (error.response && error.response.data) {
    Message({
      message: error.response.data.content || '發生錯誤',
      type: 'error'
    })
  }

  return Promise.reject(error)
})

export default request
